// @ts-strict-ignore
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LMChartBase } from './lm-chart-base';
import { SohoColumnComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-chart-column',
  standalone: false,
  template: `
    <div soho-column
        [dataset]="dataset"
        [redrawOnResize]="true"
        [showLegend]="showLegend"
        [emptyMessage]="{title: 'No Data Available', info: 'No Data Available', icon: 'icon-empty-no-data-new'}"
        [type]="type"
        [isStacked]="isStacked"
        [animate]="animate"

        (selected)="onSelected($event)"
        (rendered)="onRendered($event)"
        (unselected)="onUnselected($event)"
        (contextmenu)="onContextMenu($event)"
    ></div>
    <!-- FOR column CHART
         format(value: string)    formatterString(value: string)   ticks(value: object[])
         -->
            `,
  styles: [ `:host{height:100%}` ]
})
export class LMChartColumnComponent extends LMChartBase {
  @ViewChild(SohoColumnComponent, { static: true }) sohoColumnComponent: SohoColumnComponent;

  @Input() isStacked: boolean;

  constructor(
    public elementRef: ElementRef,
  ) {
    super(elementRef);
  }

  public getChartComponent() {
    return this.sohoColumnComponent;
  }
}
